import { __rest } from "tslib";
import { handleActions } from 'redux-actions';
import produce from 'immer';
import { clearPassengerFilters, setSelectedFilters } from './actions';
const initialState = {};
const selectedPassengersFiltersReducer = handleActions({
    [setSelectedFilters.toString()]: (state, { payload }) => produce(state, draft => {
        draft[payload.passengerId] = payload.filters;
    }),
    [clearPassengerFilters.toString()]: (state, { payload }) => produce(state, draft => {
        const _a = draft, _b = payload.passengerId, removed = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return rest;
    })
}, initialState);
export default selectedPassengersFiltersReducer;
